import Tabs from "@stardust/tabs";
import { initAccordion } from "@stardust/accordion";

class ProductInfo {
  constructor(element) {
    this.element = element;
    this.init();
  }

  init() {
    // Initialize tabs for desktop
    const tablist = this.element.querySelector('[role="tablist"]');
    if (tablist) {
      this.tabs = new Tabs(tablist);
    }

    // Initialize accordion for mobile
    const accordionContainer = this.element.querySelector('[data-accordion="mobile-product-info"]');
    if (accordionContainer) {
      const exclusive = accordionContainer.dataset.accordionExclusive === "true";
      initAccordion(accordionContainer, { exclusive });
    }
  }
}

// Auto-initialize
document.querySelectorAll('[data-section-type="product-info"]').forEach((el) => {
  new ProductInfo(el);
});
